import type { NuxtRuntimeConfig } from '@nuxt/types/config/runtime'
import type { NuxtAxiosInstance } from '@nuxtjs/axios'
import {
  AddressService as PublicAddressService,
  BaseInfoService as PublicBaseInfoService,
  CashbackService as PublicCashbackService,
  HandbookService as PublicHandbookService,
  InvoiceRequirementService as PublicInvoiceRequirementService,
  OfferService as PublicOfferService,
  PromoCodeService as PublicPromoCodeService,
  SalesService as PublicSalesService,
  WhiteLabelService as PublicWhiteLabelService,
  FeedbackService as PublicFeedbackService,
} from '@alao-frontend/erp-services'
import { CommonService } from '~/services/common.service'
import { FilesService } from '~/services/files.service'
import { GeocodeService } from '~/services/geocode.service'
import { OfferService } from '~/services/offer.service'
import { OrderService } from '~/services/order.service'
import { RatingService } from '~/services/rating.service'
import { TrackerService } from '~/services/tracker.service'
import { NotifierService } from '~/services/notifier.service'
import { EmarsysService } from '~/services/emarsys.service'
import { LemurService } from '~/services/lemur.service'

// TODO:
//  1. Come up with the idea how to create services in a more convenient way
export const createServices = (
  httpClient: NuxtAxiosInstance,
  runtimeConfig: NuxtRuntimeConfig,
) => {
  return {
    CommonService: new CommonService(httpClient, runtimeConfig),
    FilesService: new FilesService(httpClient, runtimeConfig),
    GeocodeService: new GeocodeService(httpClient, runtimeConfig),
    OfferService: new OfferService(httpClient, runtimeConfig),
    OrderService: new OrderService(httpClient, runtimeConfig),
    RatingService: new RatingService(httpClient, runtimeConfig),
    TrackerService: new TrackerService(httpClient, runtimeConfig),
    NotifierService: new NotifierService(httpClient, runtimeConfig),
    EmarsysService: new EmarsysService(httpClient, runtimeConfig),
    LemurService: new LemurService(httpClient, runtimeConfig),
    PublicSalesService: new PublicSalesService(httpClient, { ...runtimeConfig, BASE_API_URL: runtimeConfig.BASE_API_URL }),
    PublicAddressService: new PublicAddressService(httpClient, { ...runtimeConfig, BASE_API_URL: runtimeConfig.BASE_API_URL }),
    PublicBaseInfoService: new PublicBaseInfoService(httpClient, { ...runtimeConfig, BASE_API_URL: runtimeConfig.BASE_API_URL }),
    PublicOfferService: new PublicOfferService(httpClient, { ...runtimeConfig, BASE_API_URL: runtimeConfig.BASE_API_URL }),
    PublicHandbookService: new PublicHandbookService(httpClient, { ...runtimeConfig, BASE_API_URL: runtimeConfig.BASE_API_URL }),
    PublicPromoCodeService: new PublicPromoCodeService(httpClient, { ...runtimeConfig, BASE_API_URL: runtimeConfig.BASE_API_URL }),
    PublicWhiteLabelService: new PublicWhiteLabelService(httpClient, { ...runtimeConfig, BASE_API_URL: runtimeConfig.BASE_API_URL }),
    PublicCashbackService: new PublicCashbackService(httpClient, { ...runtimeConfig, BASE_API_URL: runtimeConfig.BASE_API_URL }),
    PublicInvoiceRequirementService: new PublicInvoiceRequirementService(httpClient, { ...runtimeConfig, BASE_API_URL: runtimeConfig.BASE_API_URL }),
    PublicFeedbackService: new PublicFeedbackService(httpClient, { ...runtimeConfig, BASE_API_URL: runtimeConfig.BASE_API_URL }),
  } as const
}
